<template>
  <div>
    <h2
      v-if="attrs.level === 2"
    >
      <template
        v-for="(cont, index) in content"
      >
        <template v-if="cont.marks">
          <StyledContent :key="index" :content="cont" />
        </template>
        <template v-else>{{ cont.text }}</template>
      </template>
    </h2>
    <h3
      v-if="attrs.level === 3"
    >
      <template
        v-for="(cont, index) in content"
      >
        <template v-if="cont.marks">
          <StyledContent :key="index" :content="cont" />
        </template>
        <template v-else>{{ cont.text }}</template>
      </template>
    </h3>
  </div>
</template>

<script>

import StyledContent from '@/components/post/Blocks/StyledContent.vue'

export default {
  name: 'Heading',
  props: ['content', 'attrs'],
  components: {
    StyledContent
  }
}
</script>

<style lang="scss" scoped>
h2, h3 {
  font-weight: bold;;
}
</style>
